// URL helpers: uid encoding for path segments, absolute links for copying and region path rewriting (a region switch keeps the screen, or opens the section index when the route has path params beyond $region such as a chart key, a document or an assessment).
export function encodeUid(uid: string): string {
  return encodeURIComponent(uid);
}

export function absoluteUrl(href: string): string {
  return new URL(href, window.location.origin).toString();
}

export const REGION_SPECIFIC_PARAMS = ["doc", "req", "asm", "clause", "curve", "term"] as const;

export function regionSubpath(pathname: string): string {
  const segments = pathname.split("/").filter(Boolean);
  return segments.length > 1 ? `/${segments.slice(1).join("/")}` : "";
}

const REGION_SPECIFIC = new Set<string>(REGION_SPECIFIC_PARAMS);

export interface RegionSwitchTarget {
  to: string;
  section: boolean;
}

export function regionSwitchTarget(pathname: string, fullPath: string, region: string): RegionSwitchTarget {
  const segments = pathname.split("/").filter(Boolean).slice(1);
  const pattern = fullPath.split("/").filter(Boolean).slice(1);
  const bound = pattern.findIndex((segment) => segment.startsWith("$"));
  const kept = bound === -1 ? segments : segments.slice(0, Math.min(bound, 1));
  return { to: ["", region, ...kept].join("/"), section: kept.length < segments.length };
}

export function withoutRegionParams(search: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(search).filter(([key]) => !REGION_SPECIFIC.has(key)));
}

export function docUidOf(uid: string): string {
  const hash = uid.indexOf("#");
  return hash === -1 ? uid : uid.slice(0, hash);
}
